import {Component, OnInit, ViewChild} from "@angular/core";
import {
    ClassificatorQuery,
    ClassificatorsQuery,
    FilterModel,
    LeModalService,
    numberCompare,
    PRIVILEGES,
    stringCompare, TableComponent
} from "common-shared";
import {map, takeUntil} from "rxjs/operators";
import {BehaviorSubject, combineLatest, Observable} from "rxjs";
import {Table} from "primeng/table";
import {plainToInstance} from "class-transformer";
import {StateService} from "../../../core/services/state.service";
import {ClassificatorValueService} from "../../../system/classificator/classificator-value.service";
import {ClassificatorEditModalComponent} from "../classificator-edit-modal/classificator-edit-modal.component";

@Component({
  selector: 'classificator-list',
  templateUrl: './classificator-list.component.html'
})
export class ClassificatorListComponent extends TableComponent implements OnInit {
  classificators$: Observable<ClassificatorListQuery[]>;
  filter$: BehaviorSubject<FilterModel<ClassificatorQuery>>
  @ViewChild(Table) table: Table;
  protected readonly PRIVILEGES = PRIVILEGES;

  constructor(public classificatorsQuery: ClassificatorsQuery, public classificatorValueService: ClassificatorValueService, private modalService: LeModalService, private state: StateService) {
    super()
  }

  ngOnInit() {
    this.restoreFilterState();
    this.mapClassificators();
  }

  ngAfterViewInit() {
    this.configureFilter();
  }

  private restoreFilterState() {
    const filterState = this.state.getFilterState<ClassificatorQuery>() || new FilterModel<ClassificatorQuery>({Data: new ClassificatorQuery()});
    this.filter$ = new BehaviorSubject<FilterModel<ClassificatorQuery>>(filterState);
  }

  private mapClassificators() {
    this.classificators$ = combineLatest(
      [this.classificatorsQuery.getAll$, this.classificatorValueService.getAll$])
      .pipe(map(([cls, clvs]) => {
          let classificators = plainToInstance(ClassificatorListQuery, cls);
          classificators.forEach(cl => {
            const clvsForCl = clvs.filter(clv => clv.ClassificatorId === cl.Id).sort((a, b) => numberCompare(a, b, obj => obj.Sequence) || stringCompare(a, b, obj => obj.Value));
            cl.ClassificatorValues = clvsForCl;
            cl.FlattenedValues = clvsForCl.map(clv => clv.Value).join('; ');
          });
          return classificators;
        })
      );
  }

  private configureFilter() {
    this.filter$.pipe(takeUntil(this.componentDestroyed), map(filter => {
      this.state.setFilterState(filter);
      this.table?.filterGlobal(filter.Global, 'contains');
    })).subscribe();
  }

  edit(id: string): void {
    this.modalService.show(ClassificatorEditModalComponent, {initialState: {classificatorId: id}, class: 'modal-lg', ignoreBackdropClick: true});
  }
}

class ClassificatorListQuery extends ClassificatorQuery {
  FlattenedValues: string;
}
